import React from "react";
import Index from "../components/printer";

function Printer() {
	return <Index />;
}

export default Printer;
